import { render, staticRenderFns } from "./blockExercise.vue?vue&type=template&id=0161656e&scoped=true"
import script from "./blockExercise.vue?vue&type=script&lang=js"
export * from "./blockExercise.vue?vue&type=script&lang=js"
import style0 from "./blockExercise.vue?vue&type=style&index=0&id=0161656e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0161656e",
  null
  
)

export default component.exports